import { type AnimationEventHandler } from 'react';

import Box from '@mui/material/Box';
import { type SxProps, type Theme } from '@mui/material/styles';
import clsx from 'clsx';
import CloudImage from '@erikdakoda/ui/components/CloudImage';

type Props = {
  className?: 'solid' | 'outlined' | 'animated' | string | string[];
  sx?: SxProps<Theme>;
  handleAnimationEnd?: AnimationEventHandler<SVGPathElement> | undefined;
};

const ForgenticMark = ({ className = 'solid', sx }: Props) => {
  return (
    <Box className={clsx('forgentic-mark', className)} sx={sx}>
      <CloudImage cloudId="v1780347970/Logos/Forge_Logomark" alt="Forgentic Mark" />
    </Box>
  );
};

export default ForgenticMark;
